import image1 from '@/assets/images/news/detail/20200925/1.jpeg';
import image2 from '@/assets/images/news/detail/20200925/2.jpeg';

export default {
  id: '20200925', //  模块 id
  title: '叮咚买菜两年助农销售超5亿元 用生鲜数字化助力农业现代化', // 标题
  origin: '2020-09-25 13:41 来源：中国新闻网', // 新闻来源
  editor: '编辑：中国新闻网官方帐号', // 编辑者
  content: [
    {
      type: 0,
      text:
        '2020年是全面打赢脱贫攻坚战的收官之年。作为链接农业产地和消费市场的生鲜电商平台，叮咚买菜一直致力于推动和发展数字化生鲜，始终把推动农产品上行作为公司重要目标，不断助力贫困地区实现脱贫摘帽。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text: '科技加持 智慧供应链推动农业现代化',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '为了更好地帮助农产品走出“贫困”，叮咚买菜利用智慧供应链，通过打通传统生鲜行业的多重中间环节，最大程度地缩短从田间到餐桌的流通环节，进行价值重新分配，帮助农产品打出品牌，更精准把握市场需求，从而带动农业的良性循环。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '“我们希望通过叮咚买菜的生鲜数字化能力，推动商户的收益确定性，从而实现农产品生产端和消费端的两头获利，来推动上游的农业现代化。”叮咚买菜创始人兼CEO梁昌霖表示。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '据悉，叮咚买菜目前生鲜直供产地达到350个，产地直供供应商超600家。以贵州赤水冬笋为例，由于地缘限制、受困于物流及渠道，竹笋的销售一直局限于西南，价格也卖不上去。2019年，叮咚买菜通过对当地种植户、合作经销商及消费目标群的精准把控，形成了一套适合赤水竹笋、更有市场前景的产品定位和营销方案，仅一个月的时间就完成了近150吨赤水冬笋的采购量。      ',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '今年，叮咚买菜还将继续通过产地直播、平台端开设“叮咚助农优品馆”专区等形式助农纾困，加大赤水冬笋的采购和销售。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text: '科技扶贫 加快扶贫产品标准化体系建设',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '叮咚买菜在长期帮扶实践中，针对不同类别农产品种养殖生产环节，定向帮助贫困地区建立技术标准化体系；在生产、成品验收环节帮助建立采收分拣技术标准化体系；在仓储、运输环节建立冷链与智慧物流技术管理标准化体系。以此三大基本标准化体系为框架，叮咚买菜向贫困地区输出集种植标准、采收分拣标准和冷链物流标准的一体化解决方案，继而打造贯通线上全链条的农特产品生态体系，推动电商助力农户农企，实现“互联网+农业”融合发展。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '除此之外，叮咚买菜通过“叮咚大学”、“叮咚研究院”为贫困地区农特产品企业开发对应培训课程，通过采取集中与分散、室内与田间、线上与线下相结合的多种培训方式为企业生产经营提供必要辅导，支持部分有实力的龙头农业企业或者农民合作社实现技术先行、依据反馈信息及时调整农产品各标准体系之间无缝衔接、信息有效对接，形成建设—反馈—完善的技术闭环，使农产品标准化体系建设能够适应快速变化的市场环境。',
      isIndent: false,
    },
    {
      type: 0,
      text: '叮咚买菜的助农成绩单',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '自叮咚买菜电商扶贫战略实施两年以来，已完成与61个国家级贫困县实现对接，在全国范围内打造数十个电商脱贫样板县，包括贵州桐梓、贵州赤水、云南宾川、河北滦平、新疆莎车、广西隆安、广西西林等，来自样板县的方竹笋、宾川葡萄、隆安火龙果等数十种生鲜产品脱颖而出。',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '相关数据显示，叮咚买菜与贵州、广西、云南等18个省及自治区(71市)的600余家企业共对接各类扶贫产品近2500种，上线产品超500种，覆盖水果、蔬菜、肉禽蛋、水产、粮油共5大品类，扶贫商品销售总额达到5.2亿元，直接带动贫困地区1万人就业。其中，2020年上半年累计销售超3亿元，扶贫产品采购量超3.5万吨，帮助贫困户增收超过7000万元。      ',
      isIndent: false,
    },
  ],
};
